import { render } from "./Rule.vue?vue&type=template&id=74bf8e2a&scoped=true"
import script from "./Rule.vue?vue&type=script&lang=js"
export * from "./Rule.vue?vue&type=script&lang=js"

import "./Rule.vue?vue&type=style&index=0&id=74bf8e2a&scoped=true&lang=css"

import exportComponent from "/Users/hrko/_HACKERSANDDESIGNERS/Code/chatty-latest/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bf8e2a"]])

export default __exports__